export default {
    delete_cannedcommand_title: "Delete Canned Command",
    delete_cannedcommand_success_message: "The canned command has been deleted",
    delete_cannedcommand_error_message: "It was not possible to delete the canned command",
    delete_cannedcommand_label: "Are you sure you want to delete the canned command?",
}